import { io } from 'socket.io-client';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
const socket = io(API_URL, {
  transports: ['polling', 'websocket'], // Allow polling for fallback
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000
});

export default socket;
